const sentenceInCapitalized = (text) => {
  if (text === null) {
    return null;
  }

  return text?.replace(/\w\S*/g, function (txt) {
    return txt?.charAt(0)?.toUpperCase() + txt?.substr(1)?.toLowerCase();
  });
};

export default sentenceInCapitalized;
